module.exports = __webpack_public_path__ + "img/bfdys.c94d3b24.png";